import { makeStateKey, StateKey } from "@angular/platform-browser";

export class StateKeyGenerator {
    public static key<T>(directory: string, component: string, variable: string): StateKey<T> {
        return makeStateKey<T>(`${directory}/${component}_${variable}`);
    }
}
